import React from 'react';
import './StarRatingDisplay.css';

// Estrelas somente leitura, sempre roxas — usadas na tabela/painel de
// avaliações. Diferente de StarRating.jsx (input clicável, cor amarela)
// usado no formulário legado de criação manual. Usa font-awesome (fa-star)
// como o resto do projeto, em vez de react-icons, pra ter um glifo
// preenchido de verdade sem depender de fill de SVG.
const StarRatingDisplay = ({ rating = 0, size = 16 }) => {
  const rounded = Math.round(rating);
  return (
    <div className="star-rating-display" role="img" aria-label={`${rating} de 5 estrelas`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <i
          key={i}
          className={`fa ${i <= rounded ? 'fa-star' : 'fa-star-o'} star-rating-display__star`}
          style={{ fontSize: size }}
        />
      ))}
    </div>
  );
};

export default StarRatingDisplay;
